import { ConvenioAbonoService } from './../../services/convenio-abono/convenio-abono.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogTipoRechazoPagoConvenio } from './convenio-abono-rechazar.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

export interface DialogData
{
    fechaAbono:any
    idPlanPago:any
    archivos: any
    idPostulacion: any
    montoSolicitado: any
    rutUsuario: any
    nombreUsuario: any
    apellidoUsuario: any    
    rol:any
    recarga:any
    cantidadCuotas:any
    idCodeudor1:any
    idCodeudor2:any
    idPrestamo:any
    tipoPrestamo:any
    idTipoPrestamo:any
    montoCuota:any
    fechaPrimerPago:any
    deshabilitado:boolean
    presionaEditar:boolean
    mostrarEditar:any
    disponiblePago:any
    idCantidadCuota: any,
    mostrarAprobarButton:any
    rutCodeudor1:any
    nombreCodeudor1:any
    apellidoCodeudor1: any
    rutCodeudor2:any
    nombreCodeudor2:any
    apellidoCodeudor2: any
    totalMaximo:any
    idUsuario:any
    tipos:any
    cuotas:any
    planes:any
    numCuota:any
    tasaInteres: any
    valorCuota:any
    fechaPago:any
}

declare const Rut: any;
@Component({
  selector: 'app-convenio-validar',
  templateUrl: '../../pages/convenio-abono/convenio-validar-pago.html',
  styleUrls: ['../../pages/convenio-abono/convenio-abono.component.css']
})
export class DialogValidarPagoConvenio implements OnInit
{
  
    prestamos:any
    planes: any
    user: any
    rol: string = localStorage.getItem("rol")
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
    configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
    tipoPostulacion : string = "Pagadas"
    allComplete: boolean = false
    prestamoSolicitado: any
    idEjecutivo = localStorage.getItem("idUsuario")
    nombreUsuario: any
    rutUsuario:any
    totalMaximo: any
    router : any
    cantidadArchivos = 1
    deshabilitado: true
    afiliado: any = {rutAfiliado:'',idAfiliado: '',nombreAfiliado:'', apellidoAfiliado:''};
    
    pagoPrestamo: any = {
      montoSolicitado: this.data.montoSolicitado,
      idPostulacion:this.data.idPostulacion,
      idPrestamo: this.data.idPrestamo,
      cantidadCuotas:this.data.numCuota,
      idUsuario: localStorage.getItem("idUsuario"),
      idPlanPago: this.data.idPlanPago,
      idAfiliado:this.data.idUsuario,idCodeudor1:this.data.idCodeudor1,
      idCodeudor2:this.data.idCodeudor2,tipoPrestamo:this.data.tipoPrestamo,
      archivo: [], archivoTest: null,
      planes:[]}
    
 constructor( public dialogRef: MatDialogRef<DialogValidarPagoConvenio>,
   public convenioAbonoService:ConvenioAbonoService,
   @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog ){
 }

  
    ngOnInit(): void
    { this.loadData() }
   
    loadData()
    {
      
    }
   
    pageChanged(event: any) {  this.config.currentPage = event 
        
      this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
      this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage ) }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    salir() { this.router.navigate(['/index']) }
  
    seleccionaArchivo(event: any, numero: number)
    {
      if(event.target.files.length > 0)
      {
         // console.log(event.target.files[0].type)

          let vm = this
          let reader = new FileReader()
          this.pagoPrestamo.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
          reader.readAsDataURL(event.target.files[0])

          reader.onload = function() {
              vm.pagoPrestamo.archivo[0] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size:event.target.files[0].size }
          }
      }
  }

  onDescargarArchivosClick(id: any)
  {   
      let vm = this
   
      vm.convenioAbonoService.traeArchivos(id).then
      (
          (archivos: any) =>
          {                
              archivos.forEach( archivo => {
                  var fileURL=`${environment.urlBlob}/${archivo.url}`    
                  window.open(fileURL,'_blank')                     
              })  
             
          }
      )
      .catch
      (
          error =>
          {
              console.log(error)
              vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
          }
      )
  }
   
    onCancelarClick() { this.dialogRef.close() }
   
    onAgregarPagoClick(form: NgForm)
    {
    
      let vm = this;
      const dialogRef = this.dialog.open(ConfirmationDialog,
        {
            data: { message: '¿Esta seguro de Ingresar la Solicitud de Pago?', buttonText: { ok: 'Si', cancel: 'No' } }
        })
      dialogRef.afterClosed().subscribe((confirmed: boolean) =>
      {
        if (confirmed)
        {
          Swal.fire({
            allowOutsideClick:false,
            icon:'info',
            text:'Cargando...'
          });
          Swal.showLoading();
         
          let sizeArchivos=0;
          for(let i = 0; i < this.cantidadArchivos; i++)
          {
            sizeArchivos +=  this.pagoPrestamo.archivo[i].size;
            if(sizeArchivos>25000000 ){
              this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-danger')
              Swal.close();
              return;
            }
            this.pagoPrestamo.archivo[i].sizeArchivos;
            if(this.pagoPrestamo.archivo[i].extension != "application/pdf" && this.pagoPrestamo.archivo[i].extension != "image/jpeg" &&
              this.pagoPrestamo.archivo[i].extension != "image/jpg" && this.pagoPrestamo.archivo[i].extension != "image/png")
              {
                  this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-danger')
  
                  Swal.close();
                  return false
              }   
      
          }
        
          this.convenioAbonoService.ingresarPago(localStorage.getItem("idUsuario"),this.pagoPrestamo).then(
            ()=>
              {
                this.pagoPrestamo.archivo = [];
                this.openAlertDialog('La solicitud de pago de Convenio fue ingresada exitosamente, aún debe ser validado.', 'btn-success')
                form.reset();
                Swal.close();
              }
          )
          .catch ( error =>
            {
                console.log(error)
                Swal.close();
                this.openAlertDialog('Ha ocurrido un error al ingresar un pago.', 'btn-danger')
            } )
        }
      })
    }

    onRechazarPagoClick(form: NgForm){
      let vm = this
       
      let dataRechazo: any =
      {
          idPlanPago: this.pagoPrestamo.idPlanPago,
          tiposRechazo: [],
          tipoRechazo: '',
          email: '',
          nombreCompleto: '',
          nombreProducto: 'CONVENIO'
      }

      this.convenioAbonoService.motivoRechazo(4).then
      (
          rechazos => { dataRechazo.tiposRechazo = rechazos}
      ).catch ( error => {console.log(error)} )

      const dialogRechazo = this.dialog.open(DialogTipoRechazoPagoConvenio, { width: '50%', 
          data: dataRechazo });

      dialogRechazo.afterClosed().subscribe( () =>
      {
          vm.data.recarga = true
          vm.dialogRef.close()
          form.reset();
      })
  }

  onAprobarPagoClick(form: NgForm){

    let vm = this;
    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
          data: { message: '¿Esta seguro de aprobar la Solicitud de Pago?', buttonText: { ok: 'Si', cancel: 'No' } }
      })
    dialogRef.afterClosed().subscribe((confirmed: boolean) =>
    {
      if (confirmed)
      {
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
       
        let fechaPagoAbono = vm.data.fechaAbono.split('-')[2] + '-' + 
        vm.data.fechaAbono.split('-')[1] + '-' + vm.data.fechaAbono.split('-')[0]
        this.convenioAbonoService.aprobarPago(localStorage.getItem("idUsuario"),this.pagoPrestamo,fechaPagoAbono).then(
          ()=>
          {
            this.pagoPrestamo.archivo = [];
            this.openAlertDialog('La solicitud de pago de Convenio fue aprobada exitosamente.', 'btn-success')
            this.dialogRef.close()
            Swal.close();
         
          }
          ) .catch ( error =>
          {
              console.log(error)
              Swal.close();
              this.openAlertDialog('Ha ocurrido un error al aprobar el pago.', 'btn-danger')
           
          } )
      }
   
    })

}
}
